document.addEventListener('DOMContentLoaded', function () {
    let target = $('.anni25_navs').offset().top;
    $(window).scroll(function () {
        let scrollTop = $(window).scrollTop();
        if (scrollTop >= target) {
            $('.anni25_navs').addClass('fix_top');
        } else if (scrollTop < target) {
            $('.anni25_navs').removeClass('fix_top');
        }

        $('.nav_list .nav_item a').each(function (index, item) {
            let class_name = $(item).attr('href').slice(1);
            if (
                $(`.${class_name}`).eq(0).length > 0 &&
                $(window).scrollTop() + 100 > $(`.${class_name}`).eq(0).offset().top
            ) {
                $(`.nav_list .nav_item a[href*=${class_name}]`)
                    .closest('li')
                    .addClass('active')
                    .siblings()
                    .removeClass('active');
            }
        });
    });

    $('.nav_list .nav_item a').on('click', function (e) {
        e.stopPropagation();
        //   $(this).closest('li').addClass('avtive').siblings().removeClass('active');
        let targetclass = $(this).attr('href').slice(1);
        let targetheight = $(`.${targetclass}`).offset().top - 80;
        $('html,body').animate({ scrollTop: targetheight }, 300);
    });
});